import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import styled from 'styled-components';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

const FilePreviewCard = (props: ChildProps) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;
  const { file, zoom } = props;
  const [isPdf, setIsPdf] = useState<boolean>(false);
  const [numPages, setNumPages] = useState<number>(0);

  const loadPdf = () => {
    setIsPdf(true);
  };

  const onDocumentLoadSuccess = () => {
    setNumPages(numPages);
  };

  return (
    <FilePreviewContainer>
      {!isPdf ? (
        zoom ? (
          <Zoom zoomMargin={80}>
            <img src={file} onError={loadPdf} alt="fileImage" />
          </Zoom>
        ) : (
          <img src={file} onError={loadPdf} alt="fileImage" />
        )
      ) :
      zoom ?
        <Zoom>
          <PDFContainer>
              <Document file={file} onLoadSuccess={onDocumentLoadSuccess} onLoadError={console.error}>
                <Page pageNumber={1} width={220} />
              </Document>
          </PDFContainer>
        </Zoom>
      :
      <PDFContainer>
          <Document file={file} onLoadSuccess={onDocumentLoadSuccess} onLoadError={console.error}>
            <Page pageNumber={1} width={220} />
          </Document>
      </PDFContainer>
      }
    </FilePreviewContainer>
  );
};

interface ChildProps {
  file: any;
  handleImage?: any;
  handleDelete?: any;
  zoom?: boolean;
}

//zooming pdf looks bad
const FilePreviewContainer = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  [data-rmiz-wrap] {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  .react-pdf__Page__canvas {
    max-width: 100%;
    height: auto !important;
  }
`;

const PDFContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export default FilePreviewCard;
